/**
 * Enums
 */
export var BackgroundUpdateType;
(function (BackgroundUpdateType) {
    BackgroundUpdateType["APP_UPDATE"] = "app_update";
    BackgroundUpdateType["LIVE_UPDATE"] = "live_update";
    BackgroundUpdateType["BOTH"] = "both";
})(BackgroundUpdateType || (BackgroundUpdateType = {}));
export var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority["MIN"] = "min";
    NotificationPriority["LOW"] = "low";
    NotificationPriority["DEFAULT"] = "default";
    NotificationPriority["HIGH"] = "high";
    NotificationPriority["MAX"] = "max";
})(NotificationPriority || (NotificationPriority = {}));
export var UpdateStrategy;
(function (UpdateStrategy) {
    UpdateStrategy["IMMEDIATE"] = "immediate";
    UpdateStrategy["BACKGROUND"] = "background";
    UpdateStrategy["MANUAL"] = "manual";
})(UpdateStrategy || (UpdateStrategy = {}));
export var UpdateMode;
(function (UpdateMode) {
    UpdateMode["IMMEDIATE"] = "immediate";
    UpdateMode["ON_NEXT_RESTART"] = "on_next_restart";
    UpdateMode["ON_NEXT_RESUME"] = "on_next_resume";
})(UpdateMode || (UpdateMode = {}));
export var InstallMode;
(function (InstallMode) {
    InstallMode["IMMEDIATE"] = "immediate";
    InstallMode["ON_NEXT_RESTART"] = "on_next_restart";
    InstallMode["ON_NEXT_RESUME"] = "on_next_resume";
})(InstallMode || (InstallMode = {}));
export var ChecksumAlgorithm;
(function (ChecksumAlgorithm) {
    ChecksumAlgorithm["SHA256"] = "SHA-256";
    ChecksumAlgorithm["SHA512"] = "SHA-512";
})(ChecksumAlgorithm || (ChecksumAlgorithm = {}));
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["UP_TO_DATE"] = "UP_TO_DATE";
    SyncStatus["UPDATE_AVAILABLE"] = "UPDATE_AVAILABLE";
    SyncStatus["UPDATE_INSTALLED"] = "UPDATE_INSTALLED";
    SyncStatus["ERROR"] = "ERROR";
})(SyncStatus || (SyncStatus = {}));
export var BundleStatus;
(function (BundleStatus) {
    BundleStatus["PENDING"] = "PENDING";
    BundleStatus["DOWNLOADING"] = "DOWNLOADING";
    BundleStatus["READY"] = "READY";
    BundleStatus["ACTIVE"] = "ACTIVE";
    BundleStatus["FAILED"] = "FAILED";
})(BundleStatus || (BundleStatus = {}));
export var InstallStatus;
(function (InstallStatus) {
    InstallStatus["UNKNOWN"] = "UNKNOWN";
    InstallStatus["PENDING"] = "PENDING";
    InstallStatus["DOWNLOADING"] = "DOWNLOADING";
    InstallStatus["DOWNLOADED"] = "DOWNLOADED";
    InstallStatus["INSTALLING"] = "INSTALLING";
    InstallStatus["INSTALLED"] = "INSTALLED";
    InstallStatus["FAILED"] = "FAILED";
    InstallStatus["CANCELED"] = "CANCELED";
})(InstallStatus || (InstallStatus = {}));
export var UpdateErrorCode;
(function (UpdateErrorCode) {
    // Network errors
    UpdateErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    UpdateErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    UpdateErrorCode["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
    // Download errors
    UpdateErrorCode["DOWNLOAD_ERROR"] = "DOWNLOAD_ERROR";
    UpdateErrorCode["STORAGE_ERROR"] = "STORAGE_ERROR";
    UpdateErrorCode["SIZE_LIMIT_EXCEEDED"] = "SIZE_LIMIT_EXCEEDED";
    // Security errors
    UpdateErrorCode["VERIFICATION_ERROR"] = "VERIFICATION_ERROR";
    UpdateErrorCode["CHECKSUM_ERROR"] = "CHECKSUM_ERROR";
    UpdateErrorCode["SIGNATURE_ERROR"] = "SIGNATURE_ERROR";
    UpdateErrorCode["INSECURE_URL"] = "INSECURE_URL";
    UpdateErrorCode["INVALID_CERTIFICATE"] = "INVALID_CERTIFICATE";
    UpdateErrorCode["PATH_TRAVERSAL"] = "PATH_TRAVERSAL";
    // Installation errors
    UpdateErrorCode["INSTALL_ERROR"] = "INSTALL_ERROR";
    UpdateErrorCode["ROLLBACK_ERROR"] = "ROLLBACK_ERROR";
    UpdateErrorCode["VERSION_MISMATCH"] = "VERSION_MISMATCH";
    // Permission errors
    UpdateErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    // App update errors
    UpdateErrorCode["UPDATE_NOT_AVAILABLE"] = "UPDATE_NOT_AVAILABLE";
    UpdateErrorCode["UPDATE_IN_PROGRESS"] = "UPDATE_IN_PROGRESS";
    UpdateErrorCode["UPDATE_CANCELLED"] = "UPDATE_CANCELLED";
    UpdateErrorCode["PLATFORM_NOT_SUPPORTED"] = "PLATFORM_NOT_SUPPORTED";
    // Review errors
    UpdateErrorCode["REVIEW_NOT_SUPPORTED"] = "REVIEW_NOT_SUPPORTED";
    UpdateErrorCode["QUOTA_EXCEEDED"] = "QUOTA_EXCEEDED";
    UpdateErrorCode["CONDITIONS_NOT_MET"] = "CONDITIONS_NOT_MET";
    // General errors
    UpdateErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    UpdateErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(UpdateErrorCode || (UpdateErrorCode = {}));
//# sourceMappingURL=definitions.js.map